import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 0.5, md: 1 },
        pb: { xs: 0.5, md: 1 },
        px: 3,
        textAlign: 'center',
      }}
    >
      <Box sx={{ maxWidth: '720px', mx: 'auto' }}>
        {/* Main heading */}
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2.4rem', sm: '3.5rem', md: '4.25rem' },
            fontWeight: 900,
            letterSpacing: '-0.03em',
            color: '#0f172a',
            mb: 1.5,
            lineHeight: 1.08,
            animation: 'fadeSlideUp 0.6s ease 0.1s both',
            '@keyframes fadeSlideUp': {
              from: { opacity: 0, transform: 'translateY(16px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          {t('hero.title1')}
          <Box
            component="span"
            sx={{
              color: '#10b981',
              display: 'block',
              backgroundImage: 'linear-gradient(135deg, #10b981 0%, #06b6d4 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {t('hero.title2')}
          </Box>
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body1"
          sx={{
            maxWidth: '480px',
            mx: 'auto',
            fontSize: { xs: '0.85rem', sm: '0.9rem', md: '0.95rem' },
            color: '#64748b',
            fontWeight: 400,
            lineHeight: 1.6,
            animation: 'fadeSlideUp 0.6s ease 0.2s both',
          }}
        >
          {t('hero.subtitle')}
        </Typography>
      </Box>
    </Box>
  );
};

export default Hero;
